import React, { useEffect, useRef, useState } from "react";
import { Table, Button } from "react-bootstrap";
import Layout from "../../../components/Layout";
import { useNavigate } from "react-router-dom";
import { MdModeEdit, MdDelete } from "react-icons/md";
import ToastFile from "../../../utils/ToastFile";
import { deleteTaskByID, getAllTaskbyContractor } from "../../../api/TaskApi";
import DeleteModel from "../../../components/DeleteModel";
import Loader from "../../../components/Loader";

const Task = () => {
  const [tasks, setTasks] = useState([]);
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState(0);
  const [isLoading, setIsloading] = useState(true)

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getTask();
  }, []);

  const getTask = () => {
    setIsloading(true)
    getAllTaskbyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setTasks(res?.data?.data?.tasks);
        } else {
          ToastFile("Failed to fetch tasks", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tasks:", err);
        ToastFile("Error fetching tasks", "error");
      })
      .finally(()=>{
        setIsloading(false)
      })
  };

  const openAddModal = () => {
    navigate("/tasks/add");
  };

  const openEditModal = (index) => {
    const task = tasks[index];
    navigate("/tasks/edit", {
      replace: true,
      state: { task },
    });
  };

  const deleteTask = () => {
    deleteTaskByID(tasks[deleteIndex]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Task deleted", "deleted");
          fetched.current = false;
          getTask();
        } else {
          ToastFile("Failed to delete task", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting task:", err);
        ToastFile("Error deleting task", "error");
      })
      .finally(()=>{
        setDeleteIndex(0)
        setDeleteModal(false)
      })
  };

  return (
    <Layout>
      <DeleteModel showModal={deleteModal} setShowModal={setDeleteModal} onYes={deleteTask}/>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-3">
        <h3 className="mb-0">Tasks</h3>
        <Button onClick={openAddModal} className="bg-dark">
          + Add Task
        </Button>
      </div>

      {/* Table Section - Mobile Responsive */}
      <div className="table-responsive d-none d-md-block">
        <Table striped bordered hover className="table-sm">
          <thead className="table-dark">
            <tr style={{ textAlign: 'center' }}>
              <th className="text-nowrap">Category</th>
              <th className="text-nowrap">Task Type</th>
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
          {isLoading ? <tbody>
              <tr>
                <td colSpan="3">
                  <Loader/>
                </td>
              </tr>
            </tbody>
            :
          <tbody>
            {tasks.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">
                  No task found
                </td>
              </tr>
            ) : (
              tasks.map((c, idx) => (
                <tr key={idx}>
                  <td className="text-nowrap">
                    <div className="fw-bold">{c.category}</div>
                    {c.description && (
                      <small className="text-muted d-block">{c.description}</small>
                    )}
                  </td>
                  <td className="text-nowrap">{c.workType}</td>
                  <td className="text-nowrap" style={{ textAlign: 'center' }}>
                      <button
                        className="btn btn-sm btn-outline-primary border-0"
                        onClick={() => openEditModal(idx)}
                        title="Edit"
                      >
                        <MdModeEdit size={16} />
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger border-0"
                        onClick={() => {setDeleteIndex(idx); setDeleteModal(true)}}
                        title="Delete"
                      >
                        <MdDelete size={16} />
                      </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>}
        </Table>
      </div>

      {/* Mobile Card View for Small Screens */}
      <div className="d-md-none">
        {tasks.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No task found</p>
          </div>
        ) : (
          <div className="row g-3">
            {tasks.map((c, idx) => (
              <div key={idx} className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="flex-grow-1">
                        <h6 className="card-title mb-1">{c.category}</h6>
                        {c.description && (
                          <small className="text-muted d-block">{c.description}</small>
                        )}
                      </div>
                      <div className="d-flex gap-1">
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => openEditModal(idx)}
                          title="Edit"
                        >
                          <MdModeEdit size={16} />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => {setDeleteIndex(idx); setDeleteModal(true)}}
                          title="Delete"
                        >
                          <MdDelete size={16} />
                        </button>
                      </div>
                    </div>
                    
                    <div className="d-flex justify-content-between align-items-center">
                      {/* <div>
                        <small className="text-muted d-block">Estimation Hours</small>
                        <span className="fw-bold">{c.estimationHours} hours</span>
                      </div> */}
                      {c.workType && (
                        <div className="text-end">
                          <small className="text-muted d-block">Work Type</small>
                          <span className="badge bg-info">{c.workType}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Task;
